/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/react';

export const overlayStyles = css`
  width: 328px;
  max-width: 328px;
  .confirmation {
    width: 100% !important;
    max-width: 100% !important;
    .button-container {
      justify-content: center !important;
    }
  }
`;
